var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-text"},[_c('div',{staticClass:"product-text__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"product-text__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }